window.crearPlantillaComercial = function (event) {
    event.preventDefault();
    cleanFeedback('crearPlantillaComercial', 'crearPlantillaComercialFormularioModal');

    let formData = new FormData(event.target);

    $.ajax({
        url:         urlPlantillasComerciales,
        type:        'POST',
        data:        formData,
        processData: false,
        contentType: false,
        beforeSend:  function beforeSend() {
            $('#crearPlantillaComercialBotonEnviar').prop('disabled', true);
            $('#crearPlantillaComercialBotonEnviar').html("<i class=\"ri-loader-4-line ri-formatted spinner\"></i>".concat(transAccionProcesando));
        },
    })
     .done(function (response) {
         $('#crearPlantillaComercialFormularioModalCampoTitulo').val('');
         $('.sinResultadosPlantillasComerciales').hide();
         pNotifySuccess(response.message);
         getRecursos(response.resource.id)
     })
     .fail(function (jqXHR, status, error) {
         showInvalidFeedback(jqXHR, 'crearPlantillaComercial', 'crearPlantillaComercialModal');
     })
     .always(function () {
         $("#crearPlantillaComercialBotonEnviar").prop('disabled', false);
         $("#crearPlantillaComercialBotonEnviar").html("<i class=\"ri-send-plane-2-fill ri-formatted\"></i> ".concat(transAccionCrearPlantillaComercial));
     });
}
